export * as recordDetails from './record-details'
export * as recordsList from './records-list'
export * as surveyConfiguration from './survey-configuration'
export * as userAccess from './user-access'
